module.exports = __webpack_public_path__ + "img/wiseanswered.2a83f9ea.png";